/** Mirrors Nkr.Model.Hla.Enum.HlaGeneGroup and the Description on each member. */
export const GENE_GROUPS: ReadonlyArray<{ id: number; label: string }> = [
    { id: 0, label: 'Class I' },
    { id: 1, label: 'HLA-DRB' },
    { id: 2, label: 'HLA-DQA' },
    { id: 3, label: 'HLA-DQB' },
    { id: 4, label: 'HLA-DPA' },
    { id: 5, label: 'HLA-DPB' },
];
